
// rome-ignore lint/style/noNonNullAssertion: <explanation>
export const IS_MAINNET = process.env.REACT_APP_PUBLIC_NETWORK === 'mainnet';

export const publicPaths = ['/', '/Collections', '/collection/[address]', '/vaults', '/vaults/[address]'];
export const SNIP_ADDRESS = "0x11d8848dDB89Ea0F6A7A3163F0c3269ECddf039b";
export const err_msg = "Error: You can claim if you want, by clicking on discord button.";
